module.exports = __webpack_public_path__ + "img/remixicon.95138f36.svg";